import { atom } from "recoil";

export const documentCategories = atom<any>({
  key: "documentCategories",
  default: { data: [] }, // ✅ Provide default structure
});

